export default __webpack_public_path__ + "static/media/IIT-Indore.dd1da4ca.jpg";